import React from 'react';
import classnames from 'classnames';
import { SecureHtml } from '@wix/wix-emails-secure-components';
import { cleanFont } from '../utils/font-utils/clean-font';
import { Column } from '../components/column';
import { WrapperItem } from '../components/wrapper-item';
import { Spacer } from '../components/spacer';
import { Section } from '../components/section';
import { Text } from '../components/text';
import { Group } from '../components/group/group';
import { Button } from '../components/button';
import { LinkWrapper } from '../components/link-wrapper';
import { shorthand } from '../utils/css-utils';
import { mobileFullWidthColumnClassName, mobileNoWrapColumnClassName, } from '../utils/defaults';
import { BdiWrapper } from '../components/bdi-wrapper';
import { useConfig } from '../components/config-context';
import { CommentStart, DoubleCommentStart, } from '../components/comments/comment-start';
import { CommentEnd, DoubleCommentEnd, } from '../components/comments/comment-end';
import { mixLeftColumn, mixRightColumn, mixButton, mixText, mixImageWrapper, mixSpacer, mixColumn, mixColumnNoWrap, mixSectionNoWrap, mixImageWrapperFullWidth, mixImageWithPadding, } from './mix-css-classes';
import { GenericImage } from './generic-image';
export const SectionMix = (props) => {
    const { section, cssClass, isRtl, override, overrideProps, experiments } = props;
    const { leftColumnPadding, // Left column right padding
    rightColumnPadding, // Right column left padding
    outerPadding, innerPadding, } = section;
    const sectionCssClass = `${cssClass} ${cssClass}-mix-all-css-paddings`;
    let leftColumnPaddings = '', middleColumnPaddings = '', rightColumnPaddings = '';
    if (innerPadding) {
        leftColumnPaddings = `${innerPadding.top}px ${leftColumnPadding} ${innerPadding.bottom}px ${innerPadding.left}px`;
        middleColumnPaddings = `${innerPadding.top}px ${leftColumnPadding} ${innerPadding.bottom}px ${rightColumnPadding}`;
        rightColumnPaddings = `${innerPadding.top}px ${innerPadding.right}px ${innerPadding.bottom}px ${rightColumnPadding}`;
    }
    const direction = isRtl ? 'rtl' : 'ltr';
    const firstColumnPadding = direction === 'ltr' ? leftColumnPaddings : rightColumnPaddings;
    const secondColumnPadding = direction === 'ltr' ? rightColumnPaddings : leftColumnPaddings;
    const columnPropsList = section.columnsWidths.map((column, idx, all) => {
        const columnProps = {
            verticalAlign: 'top',
            padding: middleColumnPaddings,
            cssClass: mixColumn,
            width: column.displayWidth,
        };
        if (idx === 0) {
            columnProps.padding = firstColumnPadding;
            columnProps.cssClass = mixLeftColumn;
        }
        if (idx === all.length - 1) {
            columnProps.padding = secondColumnPadding;
            columnProps.cssClass = mixRightColumn;
        }
        if (section.noWrap) {
            columnProps.cssClass = `${columnProps.cssClass} ${mixColumnNoWrap} ${mixColumnNoWrap}-${column.width || 50} ${mobileNoWrapColumnClassName}`;
        }
        if (!section.noWrap) {
            columnProps.cssClass = `${columnProps.cssClass} ${mobileFullWidthColumnClassName}`;
        }
        return columnProps;
    });
    const columns = columnPropsList.map((columnProps, idx) => {
        const key = section.layout.rows[0].columns[idx].regionIds[0];
        return (React.createElement(Column, { key: key, ...columnProps, forceWidth: !!section.noWrap },
            React.createElement(ColumnContent, { section: section, isRtl: isRtl, idx: idx, override: override, overrideProps: overrideProps, experiments: experiments })));
    });
    return (React.createElement(WrapperItem, null,
        React.createElement(Section, { backgroundColor: section.backgroundColor, borderBottom: section.borderBottom, borderLeft: section.borderLeft, borderRight: section.borderRight, borderTop: section.borderTop, cssClass: classnames(sectionCssClass, {
                [mixSectionNoWrap]: section.noWrap,
            }), padding: shorthand(outerPadding), direction: direction }, section.noWrap ? (React.createElement(Group, { direction: direction }, columns)) : (columns))));
};
const ColumnContent = ({ section, isRtl, idx, override, overrideProps, experiments, }) => {
    const regions = section.regions.reduce((acc, curr) => ({ ...acc, [curr.regionId]: curr }), {});
    const { spacerHeight } = section;
    const row = section.layout.rows[0];
    const result = [];
    row.columns[idx].regionIds.forEach((id, index) => {
        if (index > 0) {
            result.push(React.createElement(Spacer, { cssClass: mixSpacer, key: `spacer-${index}`, height: spacerHeight }));
        }
        // There are some cases when mix region in it's layout have an id that
        // doesn't exist in data.regions. So, the region that doesn't exist won't
        // be rendered and email-service won't throw an exception.
        if (!regions[id]) {
            return;
        }
        if (regions[id].type === 'image') {
            result.push(React.createElement(ColumnImage, { key: regions[id].regionId, region: regions[id], noWrap: section.noWrap, override: override, overrideProps: overrideProps }));
        }
        else if (regions[id].type === 'button') {
            result.push(React.createElement(ColumnButton, { key: regions[id].regionId, region: regions[id], override: override, overrideProps: overrideProps, experiments: experiments }));
        }
        else if (regions[id].type === 'text') {
            result.push(React.createElement(ColumnText, { key: regions[id].regionId, region: regions[id], isRtl: isRtl, override: override, overrideProps: overrideProps, experiments: experiments }));
        }
    });
    return React.createElement(React.Fragment, null, result);
};
const ColumnImage = ({ region, noWrap, override, overrideProps, }) => {
    const style = {
        width: `${100 - (region.imagePaddingLeft || 0) - (region.imagePaddingRight || 0)}%`,
    };
    const { renderComments } = useConfig();
    const classes = classnames(mixImageWrapper, {
        [mixImageWrapperFullWidth]: !noWrap,
        [mixImageWithPadding]: (region.imagePaddingLeft || region.imagePaddingRight) && !noWrap,
    });
    return (React.createElement(React.Fragment, null,
        renderComments && (React.createElement(React.Fragment, null,
            React.createElement(CommentStart, { condition: "if mso" }),
            React.createElement(GenericImage, { cssClass: classes, href: region.link, key: "image", src: region.src, width: region.width, height: region.height, style: style, imgStyle: region.imgStyle, alt: "", override: override, overrideProps: overrideProps && overrideProps(region), showAfterLoad: true, paddingLeft: region.outlookImagePaddingLeft
                    ? `${region.outlookImagePaddingLeft}px`
                    : undefined, paddingRight: region.outlookImagePaddingRight
                    ? `${region.outlookImagePaddingRight}px`
                    : undefined }),
            React.createElement(CommentEnd, null))),
        React.createElement(DoubleCommentStart, { condition: "if !mso" }),
        React.createElement(GenericImage, { cssClass: classes, href: region.link, key: "image", src: region.src, width: region.width, height: region.height, style: style, imgStyle: region.imgStyle, alt: "", override: override, overrideProps: overrideProps && overrideProps(region), showAfterLoad: true, imagePaddingLeft: region.imagePaddingLeft ? `${region.imagePaddingLeft}%` : undefined, imagePaddingRight: region.imagePaddingRight ? `${region.imagePaddingRight}%` : undefined }),
        React.createElement(DoubleCommentEnd, null)));
};
const ColumnButton = ({ region, override, overrideProps, experiments, }) => {
    const { button, minWidth, maxWidth } = region;
    return (React.createElement(Button, { key: "button", align: button.align, backgroundColor: button.backgroundColor, border: button.border, borderRadius: typeof button.borderRadius === 'number'
            ? `${button.borderRadius}px`
            : button.borderRadius, color: button.color, cssClass: `${mixButton} html-emails-button`, fontFamily: cleanFont(button.fontFamily), fontSize: button.fontSize, fontWeight: button.fontWeight?.toString(), fontStyle: button.fontStyle !== 'normal' ? button.fontStyle : undefined, href: button.href, innerPadding: button.innerPadding?.trim(), padding: "0px", textDecoration: button.textDecoration, rel: "noopener", minWidth: minWidth, maxWidth: maxWidth, override: override, overrideProps: overrideProps && overrideProps(region), experiments: experiments },
        React.createElement(LinkWrapper, { fontWeight: "inherit", isRtl: button.isRtl },
            React.createElement(BdiWrapper, { text: button.text?.trim() ? button.text : '\u00A0' }))));
};
const ColumnText = ({ region, isRtl, override, overrideProps, }) => {
    // TODO: here should be also addded fontSize and fontStyle. They previously
    // existed but their values were incorrect.
    const baseTextProps = {
        align: region.align,
        color: region.color,
        cssClass: mixText,
        fontFamily: region.fontFamily,
        paddingBottom: '0px',
        paddingTop: '0px',
        textTransform: region.textTransform,
    };
    const defaultProps = { padding: '0px' };
    const textContainerProps = isRtl ? { dir: 'rtl', style: {} } : { style: {} };
    const combinedTextProps = { ...{ ...defaultProps, ...baseTextProps } };
    combinedTextProps.align = undefined;
    textContainerProps.style = { textAlign: baseTextProps.align };
    return (React.createElement(Text, { key: "text", ...combinedTextProps, override: override, overrideProps: overrideProps && overrideProps(region) },
        React.createElement(SecureHtml, { html: region.html, containerProps: textContainerProps, skipCleaning: false })));
};
//# sourceMappingURL=section-mix.js.map